import {resources} from "../../../../../../../core/models/resource/resources";
import {EntityFileType} from "../../../../../../../core/types/file.types";

export const unitEconomicsCalculationsResourceType = resources['unit-economics-calculations'];
export const unitEconomicsCalculationsFilesResourceType = resources['unit-economics-calculations-files'];
export const unitEconomicsCalculationsFileType: EntityFileType = 'UNIT_ECONOMICS_CALCULATIONS';
